import { useCallback } from 'react';
import { statsService } from '../services/statsService';
import { type LeaderboardUser, StatsLeaderboard } from './StatsLeaderboard';

const formatDuration = (totalSecs: number): string => {
    if (totalSecs <= 0) return '0s';
    const hours = Math.floor(totalSecs / 3600);
    const minutes = Math.floor((totalSecs % 3600) / 60);
    const seconds = Math.round(totalSecs % 60);

    if (hours > 0) return `${hours}h ${minutes}m`;
    if (minutes > 0) return `${minutes}m ${seconds}s`;
    return `${seconds}s`;
};

export const VoiceConversationsLeaderboard = () => {
    const fetchUsers = useCallback(async (): Promise<LeaderboardUser[]> => {
        const users = await statsService.getTopUsersByVoiceConversationCount(20);
        return users.map((u) => ({
            userId: u.userId,
            email: u.email,
            displayName: u.displayName,
            value: u.voiceConversationCount,
            secondaryValue: formatDuration(u.totalDurationSecs),
            memberSince: u.memberSince,
            lastUsedAt: u.lastUsedAt,
        }));
    }, []);

    return (
        <StatsLeaderboard
            title="Voice Conversations Leaderboard"
            valueLabel="Voice Conversations"
            valueUnit="conversations"
            secondaryValueLabel="Total Duration"
            emptyMessage="No users with voice conversations found."
            fetchUsers={fetchUsers}
            showLastUsed
        />
    );
};
